export var DialogType;
(function (DialogType) {
    DialogType["ADD"] = "add";
    DialogType["EDIT"] = "edit";
    DialogType["VIEW"] = "view";
})(DialogType || (DialogType = {}));
